import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Component } from 'react';
import Badge from '@atlaskit/badge';
var MAX_NOTIFICATIONS_COUNT = 9;
var NAVIGATION_CHANNEL = 'navigation';

var NotificationIndicator = /*#__PURE__*/function (_Component) {
  _inherits(NotificationIndicator, _Component);

  var _super = _createSuper(NotificationIndicator);

  function NotificationIndicator() {
    var _this;

    _classCallCheck(this, NotificationIndicator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "visibilityChangesSinceTimer", 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      count: null
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibilityChange", function () {
      if (_this.props.refreshOnVisibilityChange && _this.shouldRefresh()) {
        _this.visibilityChangesSinceTimer++;

        _this.refresh('visibility');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "shouldRefresh", function () {
      return !document.hidden || _this.props.refreshOnHidden;
    });

    _defineProperty(_assertThisInitialized(_this), "timerTick", function () {
      _this.visibilityChangesSinceTimer = 0;

      _this.refresh('timer');
    });

    _defineProperty(_assertThisInitialized(_this), "handleAnalytics", function (countUpdateProperties) {
      var newCount = countUpdateProperties.newCount,
          oldCount = countUpdateProperties.oldCount,
          source = countUpdateProperties.source; // Only fire an 'activating' analytics event if the notification indicator is 'activating' for the first time
      // ie going from a number of 0 (the indicator is not visible)
      // to a number > 0 (the indicator becomes visible)

      if (_this.props.createAnalyticsEvent && newCount > 0 && oldCount === 0) {
        var event = _this.props.createAnalyticsEvent({
          actionSubject: 'notificationIndicator',
          action: 'activated',
          attributes: {
            badgeCount: newCount,
            refreshSource: source
          }
        });

        event.fire(NAVIGATION_CHANNEL);
      }

      if (_this.props.createAnalyticsEvent && newCount !== oldCount) {
        var _event = _this.props.createAnalyticsEvent({
          actionSubject: 'notificationIndicator',
          action: 'updated',
          attributes: {
            oldCount: oldCount,
            newCount: newCount,
            refreshSource: source
          }
        });

        _event.fire(NAVIGATION_CHANNEL);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "refresh", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
        var visibilityChangesSinceTimer, updatingEvent, updatingResult, count, countUpdateProperties;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.notificationLogProvider) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this.shouldRefresh()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                visibilityChangesSinceTimer = _this.visibilityChangesSinceTimer;
                updatingEvent = {
                  source: source,
                  visibilityChangesSinceTimer: visibilityChangesSinceTimer
                };
                updatingResult = _this.props.onCountUpdating && _this.props.onCountUpdating(updatingEvent) || {};

                if (!updatingResult.skip) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                _context.prev = 9;
                _context.t0 = updatingResult.countOverride;

                if (_context.t0) {
                  _context.next = 15;
                  break;
                }

                _context.next = 14;
                return _this.notificationLogProvider.countUnseenNotifications({
                  queryParams: {
                    currentCount: _this.state.count || 0
                  },
                  useV3NotificationsApi: _this.props.useV3NotificationsApi
                });

              case 14:
                _context.t0 = _context.sent.count;

              case 15:
                count = _context.t0;

                if (_this.state.count === null || _this.state.count !== count) {
                  countUpdateProperties = {
                    oldCount: _this.state.count || 0,
                    newCount: count,
                    source: source
                  };

                  _this.handleAnalytics(countUpdateProperties);

                  if (_this.props.onCountUpdated) {
                    _this.props.onCountUpdated(countUpdateProperties);
                  }

                  _this.setState({
                    count: count
                  });
                }

                _context.next = 21;
                break;

              case 19:
                _context.prev = 19;
                _context.t1 = _context["catch"](9);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 19]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(NotificationIndicator, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.props.notificationLogProvider;

              case 2:
                this.notificationLogProvider = _context2.sent;
                this.refresh('mount');
                this.updateInterval();
                document.addEventListener('visibilitychange', this.onVisibilityChange);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.refreshRate !== this.props.refreshRate) {
        this.updateInterval();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
  }, {
    key: "updateInterval",
    value: function updateInterval() {
      var refreshRate = this.props.refreshRate;

      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      if (refreshRate && refreshRate > 0) {
        this.intervalId = window.setInterval(this.timerTick, refreshRate);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var count = this.state.count;
      var _this$props = this.props,
          appearance = _this$props.appearance,
          max = _this$props.max;
      return count ? /*#__PURE__*/React.createElement("div", {
        "data-test-selector": "NotificationIndicator"
      }, /*#__PURE__*/React.createElement(Badge, {
        max: max,
        appearance: appearance
      }, count)) : null;
    }
  }]);

  return NotificationIndicator;
}(Component);

_defineProperty(NotificationIndicator, "defaultProps", {
  appearance: 'important',
  max: MAX_NOTIFICATIONS_COUNT,
  refreshRate: 0,
  refreshOnHidden: false,
  refreshOnVisibilityChange: true
});

export default NotificationIndicator;